import { render, staticRenderFns } from "./AttendanceStatistics.vue?vue&type=template&id=fded195a&scoped=true"
import script from "./AttendanceStatistics.vue?vue&type=script&lang=js"
export * from "./AttendanceStatistics.vue?vue&type=script&lang=js"
import style0 from "./AttendanceStatistics.vue?vue&type=style&index=0&id=fded195a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fded195a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fded195a')) {
      api.createRecord('fded195a', component.options)
    } else {
      api.reload('fded195a', component.options)
    }
    module.hot.accept("./AttendanceStatistics.vue?vue&type=template&id=fded195a&scoped=true", function () {
      api.rerender('fded195a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dashboard/component/AttendanceStatistics.vue"
export default component.exports